import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.dashboards')
  .factory('$dashboards', dashboardsObjectFactory);

/* @ngInject */
function dashboardsObjectFactory($bringozFactory: $bringozFactory,
                                 dashboardsAPI: BringozApi,
                                 Dashboards_DS: DataStoreConfig) {

  function $dashboards(id: string) {
    return $bringozFactory(id, dashboardsAPI, Dashboards_DS);
  }

  return $dashboards;
}
